import React from 'react';
import {Switch, Route} from 'react-router-dom';

import ChangePassword from '@/views/ChangePassword';
// b2c
import MyPlan from '@/b2c/MyPlan';
import PlanDetail from '@/b2c/PlanDetail';
import MyProfile from '@/b2c/MyProfile';
import Message from '@/b2c/Message';

// import OnlineApplicationForm from '@/b2b/OnlineApplication/Form';
import Error404 from '@/Error404';

const Routes = ({match}) => (
  <Switch>
    <Route path={match.url} exact component={MyPlan} />
    <Route path={`${match.url}/plan_detail/:id`} component={PlanDetail} />
    <Route path={`${match.url}/my_profile`} component={MyProfile} />
    <Route path={`${match.url}/message`} component={Message} />
    <Route path={`${match.url}/change_password`} component={ChangePassword} />
    <Route component={Error404} />
  </Switch>
);

export default Routes;
